import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { SingleNotificationState, ToastState } from '../../models/notification.model';

// identifier
export const NOTIFICATION_SLICE = 'notification';

// default state
const initialState: SingleNotificationState = {
  toast: null,
};

//slice
const notificationSlice = createSlice({
  name: NOTIFICATION_SLICE,
  initialState,
  reducers: {
    showToast: (state: SingleNotificationState, action: PayloadAction<ToastState>): void => {
      state.toast = action.payload;
    },
    hideToast: (state: SingleNotificationState): void => {
      state.toast = null;
    },
  },
});

//selectors
export const selectToast = (state: RootState) => state.notification.toast;

//actions
export const { showToast, hideToast } = notificationSlice.actions;

//reducer
export default notificationSlice;
